import React from "react";
import { Box, Grid, TextField, Button,  FormControl,  Typography } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup"; // Validierungsbibliothek
// import axios from "axios";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";
// import { PhoneIcon } from "lucide-react";


const ContactUsForm = () => {
//   const [appointments, setAppointments] = useState();
  const services = [
    { title: "Wallbox" },
    { title: "Photovoltaikanlagen" },
    { title: "Prüfung Wartung" },
    { title: "Smart Home" },

    { title: "Sprechanlage" },
    { title: "Überwachungskamera" },
    { title: "Netzwerktechnik" },
    { title: "Kundendienst" },

    { title: "Beleuchtung" },
    { title: "KNX" },

    { title: "Messung" },
    { title: "Siemens Logo" },
    {title:"Weitere Dienstleistungen"}
  ];

//   useEffect(() => {
//     const fetchAppointments = async () => {
//       try {
//         const response = await axios.get("http://localhost:5000/users/appointments");
//         setAppointments(response.data);
//       } catch (err) {
//         console.error(err);
//       }
//     };
  
//     fetchAppointments();
  
//     const interval = setInterval(() => {
//       fetchAppointments();
//     }, 10000); 
  
//     return () => {
//       clearInterval(interval);
//     };
//   }, []);
  

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Der Name ist erforderlich"),
    email: Yup.string()
      .email("Ungültige E-Mail-Adresse")
      .matches(/@.*\.com$/, "Die E-Mail-Adresse muss ein '@' enthalten und mit '.com' enden")
      .required("Die E-Mail-Adresse ist erforderlich"),
    phone: Yup.string()
      .matches(/^[0-9]+$/, "Die Telefonnummer darf nur Zahlen enthalten")
      .min(10, "Die Telefonnummer muss mindestens 10 Ziffern lang sein")
      .max(15, "Die Telefonnummer darf maximal 15 Ziffern lang sein")
      .required("Die Telefonnummer ist erforderlich"),
    address: Yup.string().required("Die Adresse ist erforderlich"),
    services: Yup.array().min(1, "Bitte wählen Sie mindestens einen Service aus"),
    // appointment: Yup.string().required("Bitte wählen Sie einen Termin aus"),
    message: Yup.string().required("Die Nachricht ist erforderlich"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    console.log('hi');
    // const apiUrl = "http://localhost:5000/book";
    const serviceId = process.env.REACT_APP_GMAIL_SERVICE_ID;
    const templateId = process.env.REACT_APP_GMAIL_TEMPLATE_ID;
    const userId = process.env.REACT_APP_GMAIL_PUBLIC_KEY;

    // const selectedAppointmentId =
    //   appointments && appointments.length > 0
    //     ? appointments.find((appointment) => appointment.date === values.appointment)?._id
    //     : null;
        // const date = new Date(values.appointment);

        // const formattedDate = !isNaN(date.getTime())
        //   ? date.toLocaleDateString("en-US", {
        //     year: "numeric",
        //     month: "long",
        //     day: "numeric",
        //     hour: "2-digit",
        //     minute: "2-digit",
        //     hourCycle: "h24",

        //   })
        //   :"";

    try {
    //   const response = await axios.post(
    //     apiUrl,
    //     {
    //       name: values.name,
    //       email: values.email,
    //       phone: values.phone,
    //       address: values.address,
    //       service: values.services,
    //       appointmentId: selectedAppointmentId,
    //       message: values.message,
    //     },
    //     {
    //       headers: { "Content-Type": "application/json" },
    //     }
    //   );
      emailjs.send(serviceId, templateId, 
        {
          name: values.name,
          email: values.email,
          phone: values.phone,
          address: values.address,
          service: values.services,
        //   appointment:  formattedDate,
          message: values.message,
        }, userId).then((result) => {
          console.log(result.text);
        }, (error) => {
          console.log(error.text);
        });
      toast.success("Ihr Termin wurde erfolgreich gebucht! Wir werden uns bald bei Ihnen melden.", {
        position: "top-right",
        autoClose: 20000,
        theme: "light",
      });

      resetForm({ values: { 
        name: "", 
        email: "", 
        phone: "", 
        address: "", 
        services: [], 
        // appointment: "", 
        message: "" 
      }});
    } catch (err) {
      toast.error("Es gab ein Problem beim Senden Ihrer Nachricht. Bitte versuchen Sie es erneut.", {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ padding: 2 ,marginTop: 2}}    >
      
        {/* // appointments && appointments.length>0 ? ( */}
          <Formik
        initialValues={{
          name: "",
          email: "",
          phone: "",
          address: "",
          services: [],
        //   appointment: "",
          message: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit, handleChange, values, errors, touched, handleBlur, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Name"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="E-Mail-Adresse"
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Telefonnummer"
                  name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.phone && Boolean(errors.phone)}
                  helperText={touched.phone && errors.phone}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Adresse"
                  name="address"
                  value={values.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.address && Boolean(errors.address)}
                  helperText={touched.address && errors.address}
                />
              </Grid>
              <Grid item xs={12}>
  <FormControl fullWidth>
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs={12} >
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            fontWeight: "bold",
            marginBottom: 3,
            color: "red",
            fontFamily: "Cursive",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
          }}
        >
          Dienstleistungen
        </Typography>
      </Grid>
      
      {services.map((service, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "8px 16px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              margin: "8px 0",
              backgroundColor: "#f9f9f9",
              transition: "background-color 0.3s, transform 0.2s",
              "&:hover": {
                backgroundColor: "#e3f2fd",
                transform: "scale(1.02)",
              },
            }}
          >
            <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
              <input
                type="checkbox"
                name="services"
                value={service.title}
                checked={values.services.includes(service.title)}
                onChange={handleChange}
                style={{
                  marginRight: "8px",
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                }}
              />
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: "500",
                  color: "#333",
                }}
              >
                {service.title}
              </Typography>
            </label>
          </Box>
        </Grid>
      ))}

      {touched.services && values.services.length === 0 && (
        <Grid item xs={12}>
          <Typography
            sx={{ color: "red", fontSize: "0.9rem", textAlign: "center", marginTop: 2 }}
          >
            {errors.services}
          </Typography>
        </Grid>
      )}
    </Grid>
  </FormControl>
</Grid>
{/* 
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Select
                    native
                    required
                    value={values.appointment}
                    onChange={handleChange}
                    inputProps={{ name: "appointment" }}
                  >
                    <option value="">Wählen Sie einen Termin</option>
                    {appointments &&
  appointments.map((appointment) => {
    const date = new Date(appointment.date);

    const formattedDate = !isNaN(date.getTime())
      ? date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      })
      :"";

    return (
      <option key={appointment._id} value={appointment.date}>
        {formattedDate}
      </option>
    );
  })}

                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Nachricht"
                  name="message"
                  value={values.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  multiline
                  rows={4}
                  error={touched.message && Boolean(errors.message)}
                  helperText={touched.message && errors.message}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Wird gesendet..." : "Senden"}
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>

//         ): (
//           <>
//           {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
//           <Typography variant="h6" textAlign="center" sx={{ color: "#333", fontWeight: "500" }}>
//           Es sind keine Termine verfügbar. Kontaktieren Sie uns.
//           </Typography>
         
//         </Box> */}
//         <Box sx={{ display: "flex", alignItems: "center",justifyContent: "center",  marginTop: 1 }}>
//     <PhoneIcon sx={{       color: '#fd0b0b',
//  marginRight: 1 }} />
//     <Typography variant="body1" sx={{ color: "#424242" }}>
//       <strong>Telefonnummer:</strong>{" "}
//       <a
//         href="tel:+4915901600845"
//         style={{
//           textDecoration: "none",
//           fontWeight: "bold",
//           color: '#fd0b0b',

//         }}
//       >
//         +49 1590 1600845
//       </a>
//     </Typography>
//   </Box>

        // )
      
    // </Box>
)};

export default ContactUsForm;
